<template>
    <div class="container mx-auto">
        <div class="flex flex-col">
            <div class="flex justify-between px-2 mb-6">
                <h1 class="font-bold md:text-[28px] text-[22px] text-black">My Campaigns</h1>
                <router-link to="/add-campaign" v-if="data.length > 0" class="flex">
                    <button
                        class="bg-primary flex items-center md:p-3 md:px-4 px-2 py-2 rounded-[5px] text-white text-[16px]"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16.89"
                            height="16.89"
                            viewBox="0 0 16.89 16.89"
                            class="mr-2"
                        >
                            <path
                                id="add"
                                d="M23.89,15.445A1.689,1.689,0,0,1,22.2,17.134H17.134V22.2a1.689,1.689,0,0,1-3.378,0V17.134H8.689a1.689,1.689,0,0,1,0-3.378h5.067V8.689a1.689,1.689,0,0,1,3.378,0v5.067H22.2A1.689,1.689,0,0,1,23.89,15.445Z"
                                transform="translate(-7 -7)"
                                fill="#fff"
                            />
                        </svg>
                        Create New
                    </button>
                </router-link>
            </div>
        </div>

        <div v-if="data.length < 1" class="flex flex-col gap-3 justify-center items-center">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="232"
                height="232"
                viewBox="0 0 232 232"
            >
                <defs>
                    <clipPath id="clip-path">
                        <rect
                            id="Rectangle_2940"
                            data-name="Rectangle 2940"
                            width="175.229"
                            height="204.597"
                            fill="none"
                        />
                    </clipPath>
                </defs>
                <g id="Group_17004" data-name="Group 17004" transform="translate(-567 -171)">
                    <circle
                        id="Ellipse_1279"
                        data-name="Ellipse 1279"
                        cx="116"
                        cy="116"
                        r="116"
                        transform="translate(567 171)"
                        fill="#369da3"
                        opacity="0.2"
                    />
                    <g
                        id="Group_17003"
                        data-name="Group 17003"
                        transform="translate(595.871 198.403)"
                    >
                        <g id="Group_17002" data-name="Group 17002" clip-path="url(#clip-path)">
                            <path
                                id="Path_26525"
                                data-name="Path 26525"
                                d="M38.871,110.1l2.592,37.362-16.2-7.559-4.1,16.414S55.932,175.75,59.388,175.1,54.2,98.865,54.2,98.865Z"
                                transform="translate(-6.385 -29.833)"
                                fill="#369da3"
                            />
                            <path
                                id="Path_26526"
                                data-name="Path 26526"
                                d="M38.871,110.1l2.592,37.362-16.2-7.559-4.1,16.414S55.932,175.75,59.388,175.1,54.2,98.865,54.2,98.865Z"
                                transform="translate(-6.385 -29.833)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26527"
                                data-name="Path 26527"
                                d="M77.816,203.985s18.652-6.412,25.938-12.532-30.893-80.147-30.893-80.147.583,67.906,4.955,92.679"
                                transform="translate(-21.986 -33.587)"
                                fill="#369da3"
                            />
                            <path
                                id="Path_26528"
                                data-name="Path 26528"
                                d="M77.816,203.985s18.652-6.412,25.938-12.532-30.893-80.147-30.893-80.147S73.444,179.212,77.816,203.985Z"
                                transform="translate(-21.986 -33.587)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26529"
                                data-name="Path 26529"
                                d="M162.173,209.786l-2.156.321a1.991,1.991,0,0,1,.023.319c-.163,2.772-15.153,10.151-25.735,14.144q-3.472,2.688-9.306,2.7c-.036,0-.068,0-.1,0-8.168.786-23.86-2.81-27.407-5.235l-3.826,39.129h0c.616.3,1.244.592,1.878.877q12.436,5.51,29.458,5.519,19.642,0,33.343-7.755l.2-.113c.577-.33,1.147-.668,1.706-1.019.676-.422,1.336-.859,1.988-1.3.2-.136.394-.276.591-.415q.685-.482,1.354-.978.316-.237.63-.477.667-.513,1.315-1.044c.175-.144.353-.285.526-.431.594-.5,1.178-1,1.748-1.522l0,0c-2.44-17.309-6.232-42.707-6.232-42.707"
                                transform="translate(-28.263 -63.304)"
                                fill="#737373"
                            />
                            <path
                                id="Path_26530"
                                data-name="Path 26530"
                                d="M162.173,209.786l-2.156.321a1.991,1.991,0,0,1,.023.319c-.163,2.772-15.153,10.151-25.735,14.144q-3.472,2.688-9.306,2.7c-.036,0-.068,0-.1,0-8.168.786-23.86-2.81-27.407-5.235l-3.826,39.129h0c.616.3,1.244.592,1.878.877q12.436,5.51,29.458,5.519,19.642,0,33.343-7.755l.2-.113c.577-.33,1.147-.668,1.706-1.019.676-.422,1.336-.859,1.988-1.3.2-.136.394-.276.591-.415q.685-.482,1.354-.978.316-.237.63-.477.667-.513,1.315-1.044c.175-.144.353-.285.526-.431.594-.5,1.178-1,1.748-1.522l0,0C165.965,235.183,162.173,209.786,162.173,209.786Z"
                                transform="translate(-28.263 -63.304)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26531"
                                data-name="Path 26531"
                                d="M69.133,124.089s17.28,42.24,17.493,43.733-1.707,11.094,1.067,13.653,21.333,6.827,29.226,5.333,33.493-13.013,33.707-16.64S125.24,95.716,122.04,87.183s-16.213-11.52-24.96-10.667-29.867,6.4-33.706,11.733,5.76,35.84,5.76,35.84"
                                transform="translate(-18.85 -23.047)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26532"
                                data-name="Path 26532"
                                d="M69.133,124.089s17.28,42.24,17.493,43.733-1.707,11.094,1.067,13.653,21.333,6.827,29.226,5.333,33.493-13.013,33.707-16.64S125.24,95.716,122.04,87.183s-16.213-11.52-24.96-10.667-29.867,6.4-33.706,11.733S69.133,124.089,69.133,124.089Z"
                                transform="translate(-18.85 -23.047)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26533"
                                data-name="Path 26533"
                                d="M73.608,84.111s-2.133,19.413-.853,23.467,7.1,15.2,7.1,15.2,9.751-12.217,11.67-13.5,19.627,10.027,19.627,10.027.64-12.16-1.92-22.187S102.194,76.217,100.7,74.3s-1.494,5.12-7.04,9.813-20.054,0-20.054,0"
                                transform="translate(-21.831 -22.322)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26534"
                                data-name="Path 26534"
                                d="M73.608,84.111s-2.133,19.413-.853,23.467,7.1,15.2,7.1,15.2,9.751-12.217,11.67-13.5,19.627,10.027,19.627,10.027.64-12.16-1.92-22.187S102.194,76.217,100.7,74.3s-1.494,5.12-7.04,9.813S73.608,84.111,73.608,84.111Z"
                                transform="translate(-21.831 -22.322)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26535"
                                data-name="Path 26535"
                                d="M71.9,86.764a75.54,75.54,0,0,0,8.061,14.278A70.084,70.084,0,0,0,93.085,114.63s5.987-15.43,7.6-24.642-1.151-18.423-1.151-18.423-1.151,13.818-5.987,16.581S71.9,86.764,71.9,86.764"
                                transform="translate(-21.696 -21.595)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26536"
                                data-name="Path 26536"
                                d="M71.9,86.764a75.54,75.54,0,0,0,8.061,14.278A70.084,70.084,0,0,0,93.085,114.63s5.987-15.43,7.6-24.642-1.151-18.423-1.151-18.423-1.151,13.818-5.987,16.581S71.9,86.764,71.9,86.764Z"
                                transform="translate(-21.696 -21.595)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26537"
                                data-name="Path 26537"
                                d="M84.544,95.489A97.639,97.639,0,0,1,71.9,93.333a75.549,75.549,0,0,0,8.061,14.278c.533.756,1.089,1.484,1.652,2.2l9.528-11.022Z"
                                transform="translate(-21.696 -28.164)"
                                fill="#263238"
                            />
                            <path
                                id="Path_26538"
                                data-name="Path 26538"
                                d="M84.544,95.489A97.639,97.639,0,0,1,71.9,93.333a75.549,75.549,0,0,0,8.061,14.278c.533.756,1.089,1.484,1.652,2.2l9.528-11.022Z"
                                transform="translate(-21.696 -28.164)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26539"
                                data-name="Path 26539"
                                d="M111.476,65.25s7.006,28.032,9.566,49.152,8.747,83.627,8.747,83.627,19.2-5.547,29.226-12.8,13.227-12.16,13.227-12.16-16.427-71.893-16.427-72.96,1.707-11.733,1.707-11.733S186.535,74.722,197.629,66.4s8.32-12.8,2.986-14.933-21.973.213-31.147,2.773S155.6,58.509,155.6,58.509a74.167,74.167,0,0,0-19.627,1.28c-9.387,2.133-24.5,5.461-24.5,5.461"
                                transform="translate(-33.639 -15.28)"
                                fill="#369da3"
                            />
                            <path
                                id="Path_26540"
                                data-name="Path 26540"
                                d="M111.476,65.25s7.006,28.032,9.566,49.152,8.747,83.627,8.747,83.627,19.2-5.547,29.226-12.8,13.227-12.16,13.227-12.16-16.427-71.893-16.427-72.96,1.707-11.733,1.707-11.733S186.535,74.722,197.629,66.4s8.32-12.8,2.986-14.933-21.973.213-31.147,2.773S155.6,58.509,155.6,58.509a74.167,74.167,0,0,0-19.627,1.28C126.589,61.922,111.476,65.25,111.476,65.25Z"
                                transform="translate(-33.639 -15.28)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26541"
                                data-name="Path 26541"
                                d="M132.1,174.284c-.339,1.063-.708,2.2-1.115,3.456"
                                transform="translate(-39.524 -52.591)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26542"
                                data-name="Path 26542"
                                d="M132.1,174.284c-.339,1.063-.708,2.2-1.115,3.456"
                                transform="translate(-39.524 -52.591)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26543"
                                data-name="Path 26543"
                                d="M136.251,106.281l3.277,2.086s-1.079,17-2.56,27.733a85.824,85.824,0,0,1-3.115,14.8"
                                transform="translate(-40.391 -32.071)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26544"
                                data-name="Path 26544"
                                d="M128.987,77.29c2.147,3.946,5.233,9.761,5.233,10.6,0,1.28-3.2,7.253-3.2,7.253l2,1.272"
                                transform="translate(-38.923 -23.323)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26545"
                                data-name="Path 26545"
                                d="M126.087,72.022s.339.608.872,1.575"
                                transform="translate(-38.048 -21.733)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26546"
                                data-name="Path 26546"
                                d="M126.087,72.022s.339.608.872,1.575"
                                transform="translate(-38.048 -21.733)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26547"
                                data-name="Path 26547"
                                d="M172.563,206.609a51.665,51.665,0,0,1-10.906,5.632c-10.027,3.84-11.733,4.48-11.733,4.48l1.494,5.12s17.493-3.2,25.6-12.374"
                                transform="translate(-45.24 -62.345)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26548"
                                data-name="Path 26548"
                                d="M186.885,202.453a17.18,17.18,0,0,1-1.433,1.278"
                                transform="translate(-55.961 -61.091)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26549"
                                data-name="Path 26549"
                                d="M186.885,202.453a17.18,17.18,0,0,1-1.433,1.278"
                                transform="translate(-55.961 -61.091)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26550"
                                data-name="Path 26550"
                                d="M181.247,87.547l-3.825,11.329,8.96-13.44"
                                transform="translate(-53.538 -25.781)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <line
                                id="Line_65"
                                data-name="Line 65"
                                x1="0.884"
                                y2="2.618"
                                transform="translate(128.546 56.669)"
                                fill="#fff"
                            />
                            <line
                                id="Line_66"
                                data-name="Line 66"
                                x1="0.884"
                                y2="2.618"
                                transform="translate(128.546 56.669)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26551"
                                data-name="Path 26551"
                                d="M64.846,86.519s2.133,38.827,4.48,57.813,6.186,65.92,6.186,65.92a19.7,19.7,0,0,1-12.373-6.613,68.618,68.618,0,0,1-7.253-10.453v-42.24c0-1.707-3.414-21.12-6.614-30.72s-7.893-20.693-5.12-25.386,11.52-11.733,14.72-12.587,5.76,0,5.973,4.267"
                                transform="translate(-13.069 -24.73)"
                                fill="#369da3"
                            />
                            <path
                                id="Path_26552"
                                data-name="Path 26552"
                                d="M64.846,86.519s2.133,38.827,4.48,57.813,6.186,65.92,6.186,65.92a19.7,19.7,0,0,1-12.373-6.613,68.618,68.618,0,0,1-7.253-10.453v-42.24c0-1.707-3.414-21.12-6.614-30.72s-7.893-20.693-5.12-25.386,11.52-11.733,14.72-12.587S64.632,82.253,64.846,86.519Z"
                                transform="translate(-13.069 -24.73)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26553"
                                data-name="Path 26553"
                                d="M72.438,158.329c1.206,3.769,2.377,7.117,3.331,9.263"
                                transform="translate(-21.859 -47.777)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26554"
                                data-name="Path 26554"
                                d="M72.438,158.329c1.206,3.769,2.377,7.117,3.331,9.263"
                                transform="translate(-21.859 -47.777)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26555"
                                data-name="Path 26555"
                                d="M61.822,99.081c-.36,2.771-.533,4.916-.256,5.193.853.853,4.266,3.84,4.266,3.84s-4.266,5.333-3.627,8.107c.421,1.822,3.236,12.395,6.086,21.61"
                                transform="translate(-18.537 -29.898)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26556"
                                data-name="Path 26556"
                                d="M64.463,78.715S63.338,84.83,62.541,90.2"
                                transform="translate(-18.872 -23.753)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26557"
                                data-name="Path 26557"
                                d="M64.463,78.715S63.338,84.83,62.541,90.2"
                                transform="translate(-18.872 -23.753)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <line
                                id="Line_67"
                                data-name="Line 67"
                                x1="3.773"
                                y1="1.771"
                                transform="translate(44.31 151.815)"
                                fill="#fff"
                            />
                            <line
                                id="Line_68"
                                data-name="Line 68"
                                x1="3.773"
                                y1="1.771"
                                transform="translate(44.31 151.815)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26558"
                                data-name="Path 26558"
                                d="M63.459,209.175l10.453,4.267v6.4L69.131,217.6"
                                transform="translate(-19.149 -63.12)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26559"
                                data-name="Path 26559"
                                d="M49.26,36.272l3.646,8.934s-4.74-4.923-5.834-.547,2.188,9.481,4.375,9.481,4.74.182,4.74.182,7.658,13.492,12.4,16.044,11.122,4.74,15.132,2.553,6.2-8.2,7.475-12.763.364-18.233.364-18.233L84.995,14.94s4.558-1.641,4.558-4.74S78.978,6.188,78.978,6.188,83.172,1.266,77.884.537s-22.426,9.481-22.973,9.845S57.829,4,53.454,6.371,43.973,20.41,44.52,23.145s4.74,13.127,4.74,13.127"
                                transform="translate(-13.422 -0.151)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26560"
                                data-name="Path 26560"
                                d="M49.26,36.272l3.646,8.934s-4.74-4.923-5.834-.547,2.188,9.481,4.375,9.481,4.74.182,4.74.182,7.658,13.492,12.4,16.044,11.122,4.74,15.132,2.553,6.2-8.2,7.475-12.763.364-18.233.364-18.233L84.995,14.94s4.558-1.641,4.558-4.74S78.978,6.188,78.978,6.188,83.172,1.266,77.884.537s-22.426,9.481-22.973,9.845S57.829,4,53.454,6.371,43.973,20.41,44.52,23.145s4.74,13.127,4.74,13.127Z"
                                transform="translate(-13.422 -0.151)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26561"
                                data-name="Path 26561"
                                d="M78.979,6.188S83.172,1.266,77.885.536s-22.425,9.481-22.972,9.846S57.83,4,53.454,6.37,43.973,20.409,44.52,23.144s4.74,13.127,4.74,13.127L52.907,45.2s4.193,3.828,2.734.912S51.266,36.636,52,35.724s4.376-2.37,4.558-4.376-3.464-7.839-2.37-9.3,16.591,1.276,19.326-.364-.73-5.652-.73-5.652L85,14.939s4.558-1.641,4.558-4.74S78.979,6.188,78.979,6.188"
                                transform="translate(-13.422 -0.15)"
                                fill="#737373"
                            />
                            <path
                                id="Path_26562"
                                data-name="Path 26562"
                                d="M78.979,6.188S83.172,1.266,77.885.536s-22.425,9.481-22.972,9.846S57.83,4,53.454,6.37,43.973,20.409,44.52,23.144s4.74,13.127,4.74,13.127L52.907,45.2s4.193,3.828,2.734.912S51.266,36.636,52,35.724s4.376-2.37,4.558-4.376-3.464-7.839-2.37-9.3,16.591,1.276,19.326-.364-.73-5.652-.73-5.652L85,14.939s4.558-1.641,4.558-4.74S78.979,6.188,78.979,6.188Z"
                                transform="translate(-13.422 -0.15)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26563"
                                data-name="Path 26563"
                                d="M95.47,73.142s-1.641,3.1-4.194,3.282"
                                transform="translate(-27.543 -22.071)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26564"
                                data-name="Path 26564"
                                d="M95.47,73.142s-1.641,3.1-4.194,3.282"
                                transform="translate(-27.543 -22.071)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26565"
                                data-name="Path 26565"
                                d="M79.759,60.51c.509,1.1.292,2.276-.485,2.637s-1.818-.236-2.327-1.332-.292-2.277.485-2.637,1.818.236,2.327,1.332"
                                transform="translate(-23.136 -17.825)"
                                fill="#263238"
                            />
                            <path
                                id="Path_26566"
                                data-name="Path 26566"
                                d="M100.56,56.182c.19,1.194-.341,2.271-1.186,2.4S97.69,57.863,97.5,56.67s.341-2.269,1.186-2.4,1.685.723,1.875,1.917"
                                transform="translate(-29.409 -16.371)"
                                fill="#263238"
                            />
                            <path
                                id="Path_26567"
                                data-name="Path 26567"
                                d="M91.276,87.056a9.984,9.984,0,0,0,5.287-1.641"
                                transform="translate(-27.543 -25.774)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26568"
                                data-name="Path 26568"
                                d="M91.276,87.056a9.984,9.984,0,0,0,5.287-1.641"
                                transform="translate(-27.543 -25.774)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26569"
                                data-name="Path 26569"
                                d="M68.037,56.8s2.553-3.646,9.481-1.459"
                                transform="translate(-20.531 -16.49)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                            />
                            <path
                                id="Path_26570"
                                data-name="Path 26570"
                                d="M94.41,50.805a6.947,6.947,0,0,1,6.2-4.558"
                                transform="translate(-28.489 -13.955)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                            />
                            <path
                                id="Path_26571"
                                data-name="Path 26571"
                                d="M109.032,46.821s1.276-2.917,2.735-1.094a9.07,9.07,0,0,1,1.093,7.84c-.911,2.371-1.458,4.376-1.458,4.376l-.365-2.553Z"
                                transform="translate(-32.901 -13.618)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26572"
                                data-name="Path 26572"
                                d="M109.032,46.821s1.276-2.917,2.735-1.094a9.07,9.07,0,0,1,1.093,7.84c-.911,2.371-1.458,4.376-1.458,4.376l-.365-2.553Z"
                                transform="translate(-32.901 -13.618)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26573"
                                data-name="Path 26573"
                                d="M131.94,25.61s-20.055-3.646-21.331-3.646S94.382,24.7,92.194,25.61s-18.779,5.652-18.414,6.746,2.37,1.459,2.37,1.459.365,1.641,6.2,2.371,19.508-1.094,19.691.182a3.189,3.189,0,0,1-.912,2.37l1.641,2.917s6.017-.912,8.022-2.371,7.658-6.016,7.658-6.016l12.215.911Z"
                                transform="translate(-22.262 -6.628)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26574"
                                data-name="Path 26574"
                                d="M131.94,25.61s-20.055-3.646-21.331-3.646S94.382,24.7,92.194,25.61s-18.779,5.652-18.414,6.746,2.37,1.459,2.37,1.459.365,1.641,6.2,2.371,19.508-1.094,19.691.182a3.189,3.189,0,0,1-.912,2.37l1.641,2.917s6.017-.912,8.022-2.371,7.658-6.016,7.658-6.016l12.215.911Z"
                                transform="translate(-22.262 -6.628)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26575"
                                data-name="Path 26575"
                                d="M89.154,30.842s-8.2,3.464-9.481,4.194,2.371,2.188,4.558,1.823,10.574-3.646,11.851-4.011,7.111,1.094,11.3,1.641a13.947,13.947,0,0,0,7.84-1.093"
                                transform="translate(-23.962 -9.307)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26576"
                                data-name="Path 26576"
                                d="M89.154,30.842s-8.2,3.464-9.481,4.194,2.371,2.188,4.558,1.823,10.574-3.646,11.851-4.011,7.111,1.094,11.3,1.641a13.947,13.947,0,0,0,7.84-1.093"
                                transform="translate(-23.962 -9.307)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26577"
                                data-name="Path 26577"
                                d="M203.678,55.109a32.691,32.691,0,0,1-14.08,0c-7.68-1.707-27.947-11.733-27.947-11.733l-13.866-4.053,3.2-16.213s34.986,4.266,44.8,7.893,24.106,11.947,23.68,14.933-8.32,9.386-8.32,9.386"
                                transform="translate(-44.595 -6.973)"
                                fill="#369da3"
                            />
                            <path
                                id="Path_26578"
                                data-name="Path 26578"
                                d="M203.678,55.109a32.691,32.691,0,0,1-14.08,0c-7.68-1.707-27.947-11.733-27.947-11.733l-13.866-4.053,3.2-16.213s34.986,4.266,44.8,7.893,24.106,11.947,23.68,14.933-8.32,9.386-8.32,9.386"
                                transform="translate(-44.595 -6.973)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26579"
                                data-name="Path 26579"
                                d="M55.734,157.152s12.837,14.709,23.668,9.761,16.18-36.639,16.18-36.639"
                                transform="translate(-16.818 -39.311)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26580"
                                data-name="Path 26580"
                                d="M31.6,147.209s10.163,12.7,23.668,11.5,18.052-16.849,17.918-24.6"
                                transform="translate(-9.537 -40.467)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <rect
                                id="Rectangle_2922"
                                data-name="Rectangle 2922"
                                width="21.212"
                                height="4.523"
                                transform="matrix(0.318, -0.948, 0.948, 0.318, 16.896, 117.456)"
                                fill="#7d7d7d"
                            />
                            <rect
                                id="Rectangle_2923"
                                data-name="Rectangle 2923"
                                width="21.212"
                                height="4.523"
                                transform="matrix(0.318, -0.948, 0.948, 0.318, 16.896, 117.456)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <rect
                                id="Rectangle_2924"
                                data-name="Rectangle 2924"
                                width="3.12"
                                height="7.018"
                                transform="translate(22.22 97.69) rotate(-71.43)"
                                fill="#263238"
                            />
                            <rect
                                id="Rectangle_2925"
                                data-name="Rectangle 2925"
                                width="3.12"
                                height="7.018"
                                transform="translate(22.22 97.69) rotate(-71.43)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <rect
                                id="Rectangle_2926"
                                data-name="Rectangle 2926"
                                width="21.212"
                                height="4.523"
                                transform="translate(26.358 120.634) rotate(-71.428)"
                                fill="#7d7d7d"
                            />
                            <rect
                                id="Rectangle_2927"
                                data-name="Rectangle 2927"
                                width="21.212"
                                height="4.523"
                                transform="translate(26.358 120.634) rotate(-71.428)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <rect
                                id="Rectangle_2928"
                                data-name="Rectangle 2928"
                                width="3.119"
                                height="7.019"
                                transform="translate(31.682 100.869) rotate(-71.43)"
                                fill="#263238"
                            />
                            <rect
                                id="Rectangle_2929"
                                data-name="Rectangle 2929"
                                width="3.119"
                                height="7.019"
                                transform="translate(31.682 100.869) rotate(-71.43)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <rect
                                id="Rectangle_2930"
                                data-name="Rectangle 2930"
                                width="16.221"
                                height="14.661"
                                transform="translate(16.748 117.406) rotate(-71.43)"
                                fill="#263238"
                            />
                            <rect
                                id="Rectangle_2931"
                                data-name="Rectangle 2931"
                                width="16.221"
                                height="14.661"
                                transform="translate(16.748 117.406) rotate(-71.43)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26581"
                                data-name="Path 26581"
                                d="M20.085,176.068,7.12,171.713l6.874-11.347,7.464,2.507Z"
                                transform="translate(-2.148 -48.391)"
                                fill="#7d7d7d"
                            />
                            <path
                                id="Path_26582"
                                data-name="Path 26582"
                                d="M20.085,176.068,7.12,171.713l6.874-11.347,7.464,2.507Z"
                                transform="translate(-2.148 -48.391)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <rect
                                id="Rectangle_2932"
                                data-name="Rectangle 2932"
                                width="14.515"
                                height="13.677"
                                transform="translate(0.349 137.08) rotate(-71.43)"
                                fill="#636363"
                            />
                            <rect
                                id="Rectangle_2933"
                                data-name="Rectangle 2933"
                                width="14.515"
                                height="13.677"
                                transform="translate(0.349 137.08) rotate(-71.43)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <rect
                                id="Rectangle_2934"
                                data-name="Rectangle 2934"
                                width="14.514"
                                height="11.744"
                                transform="translate(9.957 111.514) rotate(-71.428)"
                                fill="#636363"
                            />
                            <rect
                                id="Rectangle_2935"
                                data-name="Rectangle 2935"
                                width="14.514"
                                height="11.744"
                                transform="translate(9.957 111.514) rotate(-71.428)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26583"
                                data-name="Path 26583"
                                d="M47.188,185.174l-12.965-4.356L41.1,169.471l7.464,2.507Z"
                                transform="translate(-10.327 -51.139)"
                                fill="#7d7d7d"
                            />
                            <path
                                id="Path_26584"
                                data-name="Path 26584"
                                d="M47.188,185.174l-12.965-4.356L41.1,169.471l7.464,2.507Z"
                                transform="translate(-10.327 -51.139)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <rect
                                id="Rectangle_2936"
                                data-name="Rectangle 2936"
                                width="14.515"
                                height="13.677"
                                transform="translate(19.273 143.438) rotate(-71.43)"
                                fill="#636363"
                            />
                            <rect
                                id="Rectangle_2937"
                                data-name="Rectangle 2937"
                                width="14.515"
                                height="13.677"
                                transform="translate(19.273 143.438) rotate(-71.43)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <rect
                                id="Rectangle_2938"
                                data-name="Rectangle 2938"
                                width="14.514"
                                height="11.744"
                                transform="translate(28.882 117.872) rotate(-71.428)"
                                fill="#636363"
                            />
                            <rect
                                id="Rectangle_2939"
                                data-name="Rectangle 2939"
                                width="14.514"
                                height="11.744"
                                transform="translate(28.882 117.872) rotate(-71.428)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26585"
                                data-name="Path 26585"
                                d="M14.077,138.6s-1.511,2.489-1.066,3.2,4.8,3.111,5.421,3.288,2.31-.711,2.222-1.866-3.466-3.643-4.533-4.266-1.6-.711-2.044-.355"
                                transform="translate(-3.901 -41.76)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26586"
                                data-name="Path 26586"
                                d="M14.077,138.6s-1.511,2.489-1.066,3.2,4.8,3.111,5.421,3.288,2.31-.711,2.222-1.866-3.466-3.643-4.533-4.266S14.521,138.243,14.077,138.6Z"
                                transform="translate(-3.901 -41.76)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26587"
                                data-name="Path 26587"
                                d="M10.992,145.548s-.728,2.82-.1,3.372,5.493,1.593,6.14,1.584,2.007-1.348,1.589-2.428-4.37-2.488-5.571-2.776-1.737-.219-2.06.249"
                                transform="translate(-3.21 -43.793)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26588"
                                data-name="Path 26588"
                                d="M10.992,145.548s-.728,2.82-.1,3.372,5.493,1.593,6.14,1.584,2.007-1.348,1.589-2.428-4.37-2.488-5.571-2.776S11.314,145.08,10.992,145.548Z"
                                transform="translate(-3.21 -43.793)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26589"
                                data-name="Path 26589"
                                d="M9.083,152.549s-.728,2.819-.1,3.371,5.493,1.593,6.14,1.584,2.007-1.348,1.589-2.428-4.37-2.488-5.571-2.776-1.737-.219-2.06.25"
                                transform="translate(-2.634 -45.905)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26590"
                                data-name="Path 26590"
                                d="M9.083,152.549s-.728,2.819-.1,3.371,5.493,1.593,6.14,1.584,2.007-1.348,1.589-2.428-4.37-2.488-5.571-2.776S9.405,152.08,9.083,152.549Z"
                                transform="translate(-2.634 -45.905)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                            <path
                                id="Path_26591"
                                data-name="Path 26591"
                                d="M9.974,159.3s-.728,2.819-.1,3.371,5.492,1.593,6.14,1.584,2.007-1.348,1.589-2.428-4.37-2.488-5.571-2.776-1.737-.219-2.06.249"
                                transform="translate(-2.903 -47.941)"
                                fill="#fff"
                            />
                            <path
                                id="Path_26592"
                                data-name="Path 26592"
                                d="M9.974,159.3s-.728,2.819-.1,3.371,5.492,1.593,6.14,1.584,2.007-1.348,1.589-2.428-4.37-2.488-5.571-2.776S10.3,158.826,9.974,159.3Z"
                                transform="translate(-2.903 -47.941)"
                                fill="none"
                                stroke="#263238"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                            />
                        </g>
                    </g>
                </g>
            </svg>
            <p class="md:text-[37px] text-[26px] font-bold text-center">Nothing to See!</p>
            <p class="md:text-[21px] text-[18px] text-center">
                Click the button below to create your first campaign
            </p>
            <!-- <p
                class="md:text-[21px] text-[18px] my-6 text-center md:hidden flex capitalize text-primary"
            >
                Please switch to desktop mode to create campaign.
            </p> -->
            <router-link to="/add-campaign" class="md:flex">
                <button
                    class="bg-primary flex items-center p-3 px-4 rounded-[5px] text-white text-[16px] mb-24"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16.89"
                        height="16.89"
                        viewBox="0 0 16.89 16.89"
                        class="mr-2"
                    >
                        <path
                            id="add"
                            d="M23.89,15.445A1.689,1.689,0,0,1,22.2,17.134H17.134V22.2a1.689,1.689,0,0,1-3.378,0V17.134H8.689a1.689,1.689,0,0,1,0-3.378h5.067V8.689a1.689,1.689,0,0,1,3.378,0v5.067H22.2A1.689,1.689,0,0,1,23.89,15.445Z"
                            transform="translate(-7 -7)"
                            fill="#fff"
                        />
                    </svg>
                    Create New
                </button>
            </router-link>
        </div>
    </div>

    <div v-if="data.length > 0" class="container mx-auto mt-8">
        <!-- Desktop Table View -->
        <div class="overflow-x-auto hidden md:block"> <!-- Hide on mobile, show on md+ -->
            <table class="min-w-full">
                <thead>
                    <tr class="text-left bg-lightGrey">
                        <th class="font-[14px] py-2 px-4 border-b">Title</th>
                        <th class="py-2 px-4 border-b">Media</th>
                        <th class="py-2 px-4 border-b">Ad Objective</th>
                        <th class="py-2 px-4 border-b">Start Date</th>
                        <th class="py-2 px-4 border-b">End Date</th>
                        <!-- <th class="py-2 px-4 border-b">Location</th> -->
                        <th class="py-2 px-4 border-b">Budget</th>
                        <th class="py-2 px-4 border-b">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(campaign) in data" :key="campaign.id" class="bg-white">
                        <td class="py-2 px-4 border-b">{{ campaign.campaign_title }}</td>
                        <td class="py-2 px-2 border-b">
                            <img v-if="campaign.mime_type && campaign.mime_type.startsWith('image/')" :src="campaign.media_url" class="h-16 rounded-md" />
                            <video v-else :src="campaign.media_url" class="h-16 rounded-md" controls></video>
                        </td>
                        <td class="py-2 px-4 border-b">
                            <div :class="{'bg-lightGreen': campaign.advertising_goal === 'Awareness', 'bg-lightBlue': campaign.advertising_goal !== 'Awareness'}" class="flex justify-center align-center px-1 py-2 rounded-md">
                                {{ campaign.advertising_goal }}
                            </div>
                        </td>
                        <td class="py-2 px-4 border-b">{{ campaign.starts_at }}</td>
                        <td class="py-2 px-4 border-b">{{ campaign.ends_at }}</td>
                        <!-- <td class="py-2 px-4 border-b">
                            <span v-for="(country, index) in campaign.locations.countries" :key="index">{{ country.name_en }}</span>
                        </td> -->
                        <td class="py-2 px-4 border-b">{{ campaign.budget }}</td>
                        <td v-if="campaign.paid === true" class="py-2 px-4 border-b">
                            <div v-html="getCampaignsStatus(campaign)"></div>
                        </td>
                        <td v-if="campaign.paid === false" class="py-2 px-4 border-b">
                            <button @click="payForCampaign(campaign)" class="bg-primary text-white p-2 rounded-md">Pay Now</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Mobile Card View -->
        <div class="block md:hidden space-y-4 px-2"> <!-- Show on mobile, hide on md+ -->
            <div v-for="(campaign) in data" :key="campaign.id + '-mobile'" class="bg-white border border-gray-200 rounded-lg shadow p-4">
                <div class="flex flex-col space-y-3">
                    <!-- Media -->
                    <div class="w-full h-40 mb-2">
                         <img v-if="campaign.mime_type && campaign.mime_type.startsWith('image/')" :src="campaign.media_url" class="w-full h-full object-cover rounded-md" />
                         <video v-else :src="campaign.media_url" class="w-full h-full object-cover rounded-md" controls></video>
                    </div>
                    <!-- Title -->
                    <h3 class="text-lg font-semibold text-black truncate">{{ campaign.campaign_title }}</h3>
                    <!-- Details Grid -->
                    <div class="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
                        <div>
                            <span class="font-medium text-gray-500">Objective:</span>
                            <div :class="{'bg-lightGreen text-green-800': campaign.advertising_goal === 'Awareness', 'bg-lightBlue text-blue-800': campaign.advertising_goal !== 'Awareness'}" class="text-center px-1 py-1 rounded-md text-xs font-medium mt-1">
                                {{ campaign.advertising_goal }}
                            </div>
                        </div>
                        <div>
                            <span class="font-medium text-gray-500">Status:</span>
                             <div v-if="campaign.paid === true" class="mt-1" v-html="getCampaignsStatus(campaign)"></div>
                             <button v-if="campaign.paid === false" @click="payForCampaign(campaign)" class="bg-primary text-white text-xs p-1 rounded-md w-full mt-1">Pay Now</button>
                        </div>
                         <div>
                            <span class="font-medium text-gray-500">Starts:</span>
                            <span class="block text-gray-800">{{ campaign.starts_at }}</span>
                        </div>
                         <div>
                            <span class="font-medium text-gray-500">Ends:</span>
                            <span class="block text-gray-800">{{ campaign.ends_at }}</span>
                        </div>
                        <div class="col-span-2">
                             <span class="font-medium text-gray-500">Budget:</span>
                             <span class="block text-gray-800">{{ campaign.budget }}</span>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="data.length > 0" class="container mx-auto mt-4">
        <div class="flex justify-end items-center">
            <div class="flex items-center justify-between">
                <!-- <button class="p-2 mx-1 bg-lightGrey rounded-md">
                    <img src="../../assets/back-arrow.png" alt="back" />
                </button> -->
                <div v-for="page in pageLinks">
                    <button
                        :key="page.label"
                        @click="pageButtonHandler(page.label)"
                        :disabled="page.label === '...' || page.url === null"
                        :class="{'bg-primary text-white': page.active === true, 'bg-lightGrey': page.active !== true, 'bg-gray-900': page.label === '...'}"
                        class="px-3 py-1 mx-1 rounded-md">
                            {{ page.label }}
                    </button>
                </div>
                <!-- <button class="p-2 mx-1 bg-lightGrey rounded-md">
                    <img src="../../assets/forward-arrow.png" alt="next" />
                </button> -->
            </div>
        </div>
    </div>
    <ReviewAndPay v-if="ReviewPaymentState === true"
      :amount="this.currentAmount"
      :sessionID="this.currentPaymentID"
      :campaignId="this.currentCampaignID"
      @handleCancel="handleCancelEvent"
      @handleSuccess="handleSuccessEvent"
      @handleError="handleErrorEvent"
    />
    <ShowCampaignSuccess v-if="paymentStatusSuccess" @closePopup="handleClosePopupEvent" />
    <PaymentCancel v-if="paymentStatusCancel" @closePopup="handleClosePopupEvent"/>
    <PaymentFaild v-if="paymentStatusfalid" @closePopup="handleClosePopupEvent" />
</template>

<script>
import axios from "axios";
import CampaignsCard from "../../components/UI/Cards/CampaignsCard.vue";
import store from "../../store";
import Swiper from "../../components/UI/Swiper.vue";
import Swiperr from "../../components/UI/Swiperr.vue";
import { mapGetters } from 'vuex';
import ReviewAndPay from "../../components/CampaignTaps/ReviewAndPay.vue";
import PaymentCancel from "../../components/CampaignTaps/PaymentCancel.vue";
import PaymentFaild from "../../components/CampaignTaps/PaymentFaild.vue";
import ShowCampaignSuccess from "../../components/CampaignTaps/ShowCampaignSuccess.vue";
export default {
  components: { CampaignsCard, Swiper, Swiperr, ReviewAndPay, PaymentCancel, PaymentFaild, ShowCampaignSuccess },
  data() {
    return {
      data: [],
      history: [],
      totalItem: "",
      itemPerPage: "",
      currentPage: 1,
      currentPaymentID: "",
      currentAmount: "",
      currentCampaignID: "",
      paymentStatusSuccess: false,
      paymentStatusCancel: false,
      paymentStatusfalid: false,
      pages: [],
      pageLinks: [],
    };
  },
 async mounted() {
    //Change Document Title
    document.title = "dKilo Ad Manager - All Campaigns";
    await this.getCampiagns(1);

  },

  computed: {
    ...mapGetters(["getCampaignsData", "ReviewPaymentState"]),
  },
  watch: {
    ReviewPaymentState(newVal) {
        console.log("review payment changed to: ",newVal);
    }
  },
  methods: {
    pageButtonHandler(page) {
      this.getCampiagns(page);
    },
    getCampaignsStatus(campaign){
        const isActive = campaign.is_active;
        const isApproved = campaign.is_approved;
        const isExpired = campaign.is_expired;
        if (isExpired && !isActive) {
            return "<span class='text-red-500'>Expired</span>";
        }
        if (isActive && !isExpired) {
            return "<span class='text-green-500'>Active</span>";
        }
        if (!isActive && !isApproved && !isExpired) {
            return "<span class='text-yellow-500'>Pending Approval</span>";
        }
    },
    async getCampiagns(pageNumber) {
      try {
        store.commit("toggleLoading");
        await store.dispatch("getCampaigns", pageNumber);
        // this line is made because on the first page, the data returns as an array, on any other page, the data returns as an object.
        this.data = Object.values(this.getCampaignsData.data);

        console.log(this.getCampaignsData.data);
        this.totalItem = this.getCampaignsData.total;
        this.itemPerPage = this.getCampaignsData.per_page;
        this.currentPage = this.getCampaignsData.current_page;
        this.pageLinks = this.getCampaignsData.links.filter((link) => {
            return !link.label.includes("Next") && !link.label.includes("Previous");
        });
        // console.log("ressss", this.data);
        store.commit("toggleLoading");
      } catch (error) {
        store.commit("toggleLoading");
      }
    },
    payForCampaign(campaign) {
        store.commit("openReviewPayment");
        this.currentPaymentID = campaign.id;
        this.currentAmount = parseInt(campaign.budget, 10);
        this.currentCampaignID = campaign.id;
    },
    handleCancelEvent(){
        store.commit('closeReviewPayment');
        this.paymentStatusCancel = true;
    },
    async handleSuccessEvent(){
        store.commit('closeReviewPayment');
        await this.getCampiagns();
        this.paymentStatusSuccess = true;
        this.currentPaymentID = "";
        this.currentAmount = "";
    },
    handleClosePopupEvent(popupType){
        this[`${popupType}`] = false
    },
    handleErrorEvent(){
        store.commit('closeReviewPayment');
        this.paymentStatusfalid = true;
        this.currentPaymentID = "";
        this.currentAmount = "";
    },
  },
};
</script>

<style></style>
